module.exports = __webpack_public_path__ + "img/kachel-STRESS_PROBALANCE.b09b6c1e.png";